import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Container = styled.div`
	width: 100%;
	height: 100vh;
	text-align: center;
`;

const H1 = styled.h1`
	line-height: 20rem;
`;

const Error = () => {
	return (
		<Container>
			<H1>Page Not Found</H1>
			<Link to="/">Home </Link>
		</Container>
	);
};

export default Error;
